import { render, staticRenderFns } from "./UserPermissionModal.vue?vue&type=template&id=621bd71b&scoped=true&"
import script from "./UserPermissionModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionModal.vue?vue&type=style&index=0&id=621bd71b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621bd71b",
  null
  
)

export default component.exports